import React, { useMemo } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import MultiCarousel from "../../components/carousel/MultiCarousel";
import CoverStoryCard from "./CoverStoryCard";

/**
 * MagazineCoverCarousel
 * @param {{ threads: any[], userInfoById: Record<string, any>, collectionInfoById: Record<string, any>, isMobile: boolean, isLoading?: boolean }} props
 */
const MagazineCoverCarousel = ({ threads, userInfoById, collectionInfoById, isMobile, isLoading = false }) => {
  // 전달받은 순서를 그대로 사용
  const randomizedThreads = useMemo(() => {
    if (!threads || threads.length === 0) return [];
    return threads;
  }, [threads]);

  // 로딩 중이거나 데이터는 있지만 셔플이 아직 준비되지 않은 경우 스켈레톤 표시
  const shouldShowSkeleton = isLoading || (threads && threads.length > 0 && randomizedThreads.length === 0);

  if (shouldShowSkeleton) {
    return (
      <Box sx={{
        width: "100%",
        maxWidth: !isMobile ? "100vw" : "calc(100vw - 16px)",
        mb: 3,
        position: 'relative',
        px: 0,
        minWidth: 0,
        contain: 'layout style',
        boxSizing: 'border-box',
      }}>
        <Stack direction="row" spacing={0}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                flex: '1 1 33.33%',
                borderRight: index < 2 ? "1px solid" : "none",
                borderColor: "primary.main",
                minHeight: isMobile ? 120 : 180
              }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={isMobile ? 120 : 180}
                sx={{ backgroundColor: "action.hover" }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    );
  }

  if (!threads || threads.length === 0) {
    // 빈 상태에서도 플레이스홀더가 들어올 수 있도록 최소 박스 유지
    return (
      <Box sx={{ width: '100%', minHeight: isMobile ? 120 : 180, border: 0 }} />
    );
  }
  return (
    <Box sx={{
      width: "100%",
      maxWidth: !isMobile ? "100vw" : "calc(100vw - 16px)",
      mb: 3,
      position: 'relative',
      px: 0,
      // overflow: 'hidden',
      minWidth: 0,
      contain: 'layout style',
      boxSizing: 'border-box',
    }}>
      <MultiCarousel
        items={randomizedThreads}
        visible={{ xs: 2, sm: 2, md: 3, lg: 3 }}
        step={1}
        gap={0}
        showDivider={true}
        dividerColor="primary.main"
        renderItem={(th) => (
          <CoverStoryCard
            thread={th}
            user={userInfoById[collectionInfoById[th.collectionId]?.userID] || null}
            fallbackAvatarUrl={(() => {
              const col = collectionInfoById[th.collectionId];
              return (
                col?.profileImage ||
                col?.profile?.threads_profile_picture_url ||
                null
              );
            })()}
            isMobile={isMobile}
          />
        )}
      />
    </Box>
  );
};

export default MagazineCoverCarousel;


